import { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useNoticeGroupsUIContext } from "../NoticeGroupsUIContext";

const prepareFilter = (queryParams, values) => {
  const { name, definition } = values;
  const newQueryParams = { ...queryParams };
  const filter = { name, definition };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function NoticeGroupsFilter() {
  // Notice Groups UI Context
  const noticeGroupsUIContext = useNoticeGroupsUIContext();
  const noticeGroupsUIProps = useMemo(() => {
    return {
      queryParams: noticeGroupsUIContext.queryParams,
      setQueryParams: noticeGroupsUIContext.setQueryParams
    };
  }, [noticeGroupsUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(noticeGroupsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, noticeGroupsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      noticeGroupsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: "",
        definition: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="definition"
                placeholder="Açıklaması"
                onBlur={handleBlur}
                value={values.definition}
                onChange={(e) => {
                  setFieldValue("definition", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Açıklaması</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}